var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('svg',{attrs:{"width":_vm.svgWidth,"height":_vm.svgHeight}},[_c('path',{attrs:{"d":_vm.generatePath(_vm.coinData[2].sparkline_in_7d, 0),"stroke":'green',"stroke-width":"2","fill":"none"}})]),_c('br'),_c('br'),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.coinData))])])
}
var staticRenderFns = []

export { render, staticRenderFns }